module.exports = __webpack_public_path__ + "static/img/UIBg.d487351.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UIBg.png
// module id = K97g
// module chunks = 0